import Moment from 'moment'

export function buildApiParams (baseParams, filters) {
  const params = { ...baseParams }

  Object.keys(filters).forEach(key => {
    let value = filters[key]
    if (!value || value === '' || (Array.isArray(value) && !value.length)) return

    if (key.endsWith('_start') || key.endsWith('_end')) {
      params[key] = Moment(value).format('YYYY-MM-DD')
    } else if (key === 'tags' || key === 'group_id' || key === 'groups') {
      params[key] = Array.isArray(value) ? value : [value]
    } else {
      params[key] = value
    }
  })

  return params
}
